import { createContext, type ReactNode, useContext, useState } from 'react';
import { useSoChiTietCongNoExport } from './hooks/useSoChiTietCongNoExport';
import type { SearchFormValues } from './schema';

interface SoChiTietCongNoContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  queryParams: SearchFormValues | null;
  setQueryParams: (params: SearchFormValues | null) => void;
}

const SoChiTietCongNoContext = createContext<SoChiTietCongNoContextValue | null>(null);

export const useSoChiTietCongNoContext = () => {
  const context = useContext(SoChiTietCongNoContext);
  if (!context) {
    throw new Error('useSoChiTietCongNoContext must be used within SoChiTietCongNoProvider');
  }
  return context;
};

export const SoChiTietCongNoProvider = ({ children }: { children: ReactNode }) => {
  const [queryParams, setQueryParams] = useState<SearchFormValues | null>(null);
  const { exportToExcel, canExport, isExporting } = useSoChiTietCongNoExport(queryParams);

  return (
    <SoChiTietCongNoContext.Provider
      value={{
        exportToExcel,
        canExport,
        isExporting,
        queryParams,
        setQueryParams
      }}
    >
      {children}
    </SoChiTietCongNoContext.Provider>
  );
};
